export const env = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
  linkedinClientId: import.meta.env.VITE_LINKEDIN_CLIENT_ID,
  linkedinRedirectUri: import.meta.env.VITE_LINKEDIN_REDIRECT_URI,
  instagramAppId: import.meta.env.VITE_INSTAGRAM_APP_ID,
  instagramRedirectUri: import.meta.env.VITE_INSTAGRAM_REDIRECT_URI,
}

export const hasSupabaseConfig = Boolean(env.supabaseUrl && env.supabaseAnonKey)